import {
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import { ICampaignIndexResource, ICampaignRequest } from "../types";

const baseKey = "campaigns";

export const campaignService = {
	...withUpdateEndpoint<ICampaignRequest>([baseKey]),
	...withIndexEndpoint<ICampaignIndexResource>([baseKey]),
	...withStoreEndpoint<ICampaignRequest>([baseKey]),
	...withShowEndpoint<ICampaignIndexResource>([baseKey]),
	...withDestroyEndpoint([baseKey]),
};
